/**
 * Нейтральная палитра интерфейса ERP — те же значения, что у токенов
 * `pages/_detailShared/detail.styled` (рамка поля, акцент, текст). Живёт в
 * `components/constants`, как и `tagTones`: молекулы и организмы не
 * импортируют страницы, а свои hex рядом заводить не должны.
 */
export const UI_COLORS = {
  /** Рамка полей, карточек и разделителей. */
  border: 'var(--k-border-e2e8f0)',
  /** Акцент: фокус, ссылки, наведение. */
  primary: 'var(--k-fg-2563eb)',
  /** Основной текст. */
  text: 'var(--k-fg-0f172a)',
  /** Подписи и второстепенные кнопки. */
  textSecondary: 'var(--k-fg-475569)',
  /** Подсказки и счётчики. */
  textMuted: 'var(--k-fg-64748b)',
  /** Плейсхолдер. */
  placeholder: 'var(--k-fg-94a3b8)',
  /** Фон поля и карточки. */
  surface: 'var(--k-bg-ffffff)',
  /** Приглушённый фон: превью, наведение. */
  surfaceSubtle: 'var(--k-bg-f8fafc)',
} as const;

/**
 * ТЗ 0106 — знак ИИ-чата: синий → фиолетовый (те же значения, что у линий
 * колонок «Завтра» и «На этой неделе» доски задач, `taskTones`). Здесь, а не
 * на странице: кнопку чата рисует и шапка (organism), а она страницы не
 * импортирует.
 */
export const AI_ACCENT = {
  violet: 'var(--k-fg-7c3aed)',
  gradient:
    'linear-gradient(135deg, var(--k-bg-2563eb) 0%, var(--k-bg-7c3aed) 100%)',
} as const;
